import _ from "lodash";
import React from "react";
import classes from "./LockOverlay.scss";
import ProfileCascade from "UIComponents/ProfileCascade";
import { LockOutlined } from "@toddle-edu/ds-icons";
import { useI18n } from "Hooks";

const cascadeStyle = {
  width: 36,
  height: 36,
  boxShadow: "0px 0px 6px 2px rgba(0,0,0,0.4)",
};
const LockOverlay = React.memo(props => {
  const {
    userInfo,
    readOnly,
    isUnitPlan,
    userName,
    isReflectionField,
    isProject = false,
  } = props;
  const { id, firstName, lastName, profileImage } = userInfo;
  const { t } = useI18n();
  return (
    <React.Fragment>
      {!isReflectionField && (
        <div
          className={classes.container}
          style={{ opacity: readOnly ? 0.2 : 0.5 }}
          title={
            isUnitPlan && userName
              ? t("unitPlan:currently_editing_with_user", {
                  user: userName,
                })
              : null
          }
        />
      )}
      {!_.isEmpty(userInfo) && !isUnitPlan && !isReflectionField && (
        <div className={classes.profile}>
          <ProfileCascade
            items={[
              { id, value: `${firstName} ${lastName}`, imageUrl: profileImage },
            ]}
            length={1}
            customStyle={cascadeStyle}
            showToolTip={true}
            isProject={isProject}
          />
          <div className={classes.lock}>
            <LockOutlined variant="on" size="xxxx-small" iconWeight="bold" />
          </div>
        </div>
      )}
    </React.Fragment>
  );
});

LockOverlay.displayName = "LockOverlay";
export default LockOverlay;
